/**
 * Display formatting. Pure functions, so the awkward cases are pinned by tests
 * rather than discovered in a screenshot.
 */

/** Shorten a bech32 address for a table cell, keeping both ends recognisable. */
export function shortAddress(address: string, head = 10, tail = 6): string {
  if (!address) return ''
  if (address.length <= head + tail + 1) return address
  return `${address.slice(0, head)}…${address.slice(-tail)}`
}

/** Strip the scheme and trailing slash from a host URI for display. */
export function shortHost(uri: string): string {
  if (!uri) return ''
  return uri.replace(/^https?:\/\//, '').replace(/\/$/, '')
}

export function leaseStateLabel(state: string | undefined): string {
  switch (state) {
    case 'active':
      return 'Active'
    case 'insufficient_funds':
      return 'Out of funds'
    case 'closed':
      return 'Closed'
    case undefined:
    case '':
      return 'Unknown'
    default:
      return state
  }
}
